class PriceOfferCalculator {
    maxCount = 2

    constructor(offer, init = true) {
        this.el = offer ? $(offer).find("#template .calculator") : [];

        if (this.el.is('[data-rows]')) {
            this.maxCount = this.el.data('rows');
        }

        this.data = [];
        this.rowCount = 0;

        if (!this.el.length || init === false) {
            return;
        }

        this.calculationStore = $(offer).find("form textarea#calculation_store");
        this.newLineButton = this.el.find(".add-new-price");
        this.templateNewRow = this.el.find("template#new-row");

        this.recalculateRowCount();

        this.start();
        this.bind();
    }

    start() {
        this.el.find(".final-price-vehicle span, .final-price span").removeAttr("contenteditable");

        this.onChange();
    }

    bind() {
        // $(document).on('click', ".delete-row", function (el) {
        //     let rowId = $(this).data('row-id');
        //     $('#' + rowId).remove();
        // });

        $(document).on("keyup", ".calculator td", (event) => {
            this.rowCount = this.el.find("tr:not(.ignore)").length;
            this.onChange($(event.currentTarget));
        });

        this.newLineButton.off('click').on('click', () => {
            this.newLine();
        });
    }

    onChange(el) {
        if (el && (el.text().includes('Zľava') || el.text().includes('zľava'))) {
            if (el.closest("table").find('.final-discount').length === 0) {
                el.closest("tr").addClass("final-discount");
            }
        }

        this.sumPrices();
        this.createData();
    }

    newLine() {
        this.recalculateRowCount();

        if (this.rowCount >= this.maxCount) {
            return;
        }

        const newRow = $(this.templateNewRow.clone().html());

        $(newRow).find('tr').attr("id", "new-row-"+this.rowCount);
        $(newRow).find('.delete-row').attr("data-row-id", "new-row-"+this.rowCount);

        let lastElement = this.el.find('tr:not(.ignore):last');

        if(lastElement.length === 0) {
            lastElement = this.el.find('tbody');
            lastElement.prepend(newRow);
        } else {
            lastElement.after(newRow);
        }

        setTimeout(() => {
            let newElement = $(`#new-row-${this.rowCount} td:first-child`);

            newElement.find(".placeholder:first-child").trigger("focus");
            //newElement.setSelectionRange(0, newElement.text().length);
        }, 100);

        this.onChange();
        this.recalculateRowCount();
    }

    deleteRow(element) {
        let rowToRemove = element.closest('tr');

        if (rowToRemove) {
            rowToRemove.remove();
        }

        document.querySelectorAll('.PriceOffer .calculator tr:not(.add):not(.notPrice) .placeholder').forEach(function (td) {
            // Create a new 'keyup' event
            let event = new Event('keyup', {bubbles: true});

            // Dispatch the event on each selected <td> element
            td.dispatchEvent(event);
        });

        this.recalculateRowCount();
    }

    sumPrices() {
        let sum = 0;

        // Sum all prices from the second td:not(.ignore) to .final-price-vehicle td:last-child
        this.el.find('tr:not(.ignore):not(.final-discount) td:last-child').each((_, el) => {
            const tr = $(el);

            let price = this.parsedPrice(tr.text().trim());

            sum += price;
        });

        const discountElement = $('.final-discount td:last-child');

        let discount = 0;
        if (discountElement.length) {
            discount = this.parsedPrice(discountElement.text().trim());
        }

        // Calculate the final price (sum - discount)
        let finalPrice = sum - discount;

        this.el.find('.final-price-vehicle td:last-child').text(this.price(sum));  // Format to 2 decimal places

        this.el.find('.final-price td:last-child').text(this.price(finalPrice));  // Format to 2 decimal places
    }

    createData() {
        this.data = [];

        this.el.find("tr:not(.add):not(.notPrice)").each((index, el) => {
            const tr = $(el);
            const label = tr.find("td:first-child").text().trim();
            const value = tr.find("td:last-child").text().replace("&nbsp;€", "").trim();

            const parsedValue = this.parsedPrice(value);

            this.data[index] = {};
            this.data[index] = {
                label: label,
                value: !isNaN(parsedValue) ? parsedValue : value
            };
        });

        this.storeData();
    }

    storeData() {
        const json = JSON.stringify(this.data);

        this.calculationStore.text(json);
    }

    parsedPrice(value) {
        // Replace non-numeric characters except decimal and comma
        const numericValue = value.replace(/[^\d,]/g, '');

        // Replace comma with dot for float conversion
        const normalizedValue = numericValue.replace(',', '.');

        // Parse the float and get the integer part
        const parsedValue = parseFloat(normalizedValue);

        return parsedValue;
    }

    price(price) {
        const skCurrencyFormatter = new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR', // Use 'SKK' if you need the old Slovak currency
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        price = price.toFixed(0);

        return skCurrencyFormatter.format(price);
    }

    recalculateRowCount() {
        this.rowCount = this.el.find("tr:not(.ignore)").length;
        this.newLineButton.attr("disabled", this.rowCount >= this.maxCount);
    }
}

window.PriceOfferCalculator = PriceOfferCalculator;

export default PriceOfferCalculator;